/*
IMPORTANT!
This file is used by Search.vue and other lists.
Pro Tip - Changes to the searchFields and displayFields arrays will most likely require updates to queries_custom.js
 */

const searchConfig = {
  Company: {
    global: true,
    searchFields: ['name', 'phone'],
    displayFields: ['name'],
    recordPath: '/companies/{{id}}',
    searchPath: '/companies'
  },
  Account: {
    global: true,
    searchFields: [
      'name', 'phone', 'nameLegal', 'namePrevious',
      'addressPhysical.locality','addressPhysical.street_address',
      'addressMailing.locality','addressMailing.street_address','phoneBusiness','phoneSupport'
    ],
    displayFields: ['name'],
    recordPath: '/accounts/{{id}}',
    searchPath: '/accounts'
  },
  caseTargetSearchCompany: {
    searchFields: [
      'name',
      'addressPhysical.locality','addressPhysical.street_address',
      'addressMailing.locality','addressMailing.street_address','phoneBusiness','phoneSupport'
    ],
    displayFields: ['name'],
    recordPath: '/companies/{{id}}',
    searchPath: '/companies'
  },
  caseTargetSearchAccount: {
    searchFields: [
      'name', 'merchantNumber', 'phone', 'nameLegal', 'namePrevious',
      'addressPhysical.locality','addressPhysical.street_address',
      'addressMailing.locality','addressMailing.street_address','phoneBusiness','phoneSupport'
    ],
    displayFields: ['name'],
    recordPath: '/accounts/{{id}}',
    searchPath: '/accounts'
  },
  caseTargetSearchService: {
    searchFields: [
      'name', 'merchantNumber', 'nameLegal', 'namePrevious',
      'addressPhysical.locality','addressPhysical.street_address',
      'addressMailing.locality','addressMailing.street_address','phoneBusiness','phoneSupport'
    ],
    displayFields: ['name'],
    recordPath: '/services/{{id}}',
    searchPath: '/services'
  },
  caseTargetSearchProduct: {
    searchFields: [
      'name',
    ],
    displayFields: ['name'],
    recordPath: '/products/{{id}}',
    searchPath: '/products'
  },
  caseTargetSearchSalesRep: {
    searchFields: [
      'given_name', 'family_name',
    ],
    displayFields: ['name'],
    recordPath: '/salesreps/{{id}}',
    searchPath: '/salesreps'
  },

  Service: {
    global: true,
    searchFields: ['name', 'phone', 'nameLegal', 'merchantNumber','ein','amexNum','discoverNum','phoneBusiness','email','phoneSupport'],
    displayFields: ['name'],
    recordPath: '/services/{{id}}',
    searchPath: '/services'
  },
  PortfolioService: {
    searchFields: [
      'esData.service.name',
      'esData.service.description',
      'esData.service.createdAt',
    ],
    displayFields: ['name'],
    recordPath: '/services/{{id}}',
    searchPath: '/services'
  },
  TeamUser: {
    searchFields: [
      'esData.user.given_name',
      'esData.user.family_name',
      'role',
      'cognito_groupid'
    ],
    displayFields: ['name'],
    recordPath: '/teams/{{id}}',
    searchPath: '/teams'
  },
  CaseServicesCusto: {
    searchFields: [
      'esData.case.createdAt',
      'esData.case.subject',
      'esData.case.person.given_name',
      'esData.case.person.family_name',
      'esData.case.quickNote',
      'esData.case.priority',
      'esData.case.closedDate',
      'esData.case.status',
      'esData.service.name',
      'esData.service.merchantNumber',
      'esData.case.user.given_name',
      'esData.case.user.family_name',
      'esData.case.team.name',
      'esData.case.template.subject',
      ],
    displayFields: ['name'],
    recordPath: '/services/{{id}}',
    searchPath: '/services'
  },
  CaseAccountsCusto: {
    searchFields: [
      'esData.case.createdAt',
      'esData.case.subject',
      'esData.case.person',
      'esData.case.quickNote',
      'esData.case.priority',
      'esData.case.closedDate',
      'esData.case.status',
      'esData.service.name',
      'esData.service.merchantNumber',
      'esData.case.user',
      'esData.case.team.name',
      'esData.case.template.subject',
    ],
    displayFields: ['name'],
    recordPath: '/cases/{{id}}',
    searchPath: '/cases'
  },
  ProductOptionChildCustom: {
    searchFields: [
      'esData.parent.category',
      'esData.parent.name',
      'esData.child.category',
      'esData.child.name',
    ],
    displayFields: ['name'],
    recordPath: '/productoptions/{{id}}',
    searchPath: '/productoptions'
  },
  Product: {
    global: true,
    searchFields: ['name','serial'],
    displayFields: ['name'],
    recordPath: '/products/{{id}}',
    searchPath: '/products'
  },
  ProductsChildren: {
    searchFields: ['name'],
    displayFields: ['name'],
    recordPath: '/products/{{id}}',
    searchPath: '/products'
  },
  ProductChildCustom: {
    searchFields: ["esData.parent.productOption.name", "esData.parent.name","esData.child.productOption.name", "esData.child.name"],
    displayFields: ["name"],
    recordPath: "/products/{{id}}",
    searchPath: "/products",
  },
  RelatedProduct: {
    searchFields: ['name'],
    displayFields: ['name'],
    recordPath: '/products/{{id}}',
    searchPath: '/products'
  },
  Person: {
    global: true,
    searchFields: ['given_name', 'family_name', 'email', 'addressMailing.locality','addressMailing.street_address','ssn','dob','phone_mobile','phone_other','phone_number','phone_home'],
    displayFields: ['given_name', 'family_name', 'email'],
    recordPath: '/people/{{id}}',
    searchPath: '/people'
  },
  Case: {
    global: true,
    searchFields: ['subject', 'quickNote'],
    displayFields: ['subject'],
    recordPath: '/cases/{{id}}',
    searchPath: '/cases',
  },
  CaseCustom: {
    searchFields: ['id', 'subject', 'quickNote', 'createdAt'],
    displayFields: ['subject'],
    recordPath: '/cases/{{id}}',
    searchPath: '/cases',
  },
  Message: {
    global: true,
    searchFields: ['subject','body','from','to'],
    displayFields: ['subject','body','from','to'],
    recordPath: '/cases/{{id}}/messages#{{messageID}}',
    searchPath: '/messages',
  },
  User: {
    searchFields: ['id','email','given_name','family_name'],
    displayFields: ['cogUsername','given_name','family_name','email'],
    recordPath: '/users/{{id}}',
    searchPath: '/users',
  },
  Portfolio: {
    global: true,
    searchFields: ['name','description'],
    displayFields: ['name','description'],
    recordPath: '/portfolios/{{id}}',
    searchPath: '/portfolios',
  },
  PortfoliosWithDetail: {
    searchFields: ['id','name','description'],
    displayFields: ['name','description'],
    recordPath: '/portfolios/{{id}}',
    searchPath: '/portfolios',
  },
  TaskStepsList: {
    searchFields: ['id','subject','priority', 'status', 'assignee', 'type', 'quickNote'],
    displayFields: ['subject','priority', 'status', 'assignee', 'type'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks',
  },
  Team: {
    searchFields: ['id','name'],
    displayFields: ['name'],
    recordPath: '/teams/{{id}}',
    searchPath: '/teams',
  },
  HQ: {
    global: true,
    searchFields: ['name'],
    displayFields: ['name'],
    recordPath: '/hq/{{id}}',
    searchPath: '/hqs',
  },
  SalesRep: {
    global: true,
    searchFields: ['given_name','family_name','email','phone_number'],
    displayFields: ['given_name','family_name','email'],
    recordPath: '/salesreps/{{id}}',
    searchPath: '/salesreps',
  },
  ProductOption: {
    global: true,
    searchFields: ['name','category','brand','legacyName'],
    displayFields: ['name','category','brand','legacyName','status'],
    recordPath: '/productoptions/{{id}}',
    searchPath: '/productoptions',
  },
  SalesOffice: {
    searchFields: ['id','name','createdAt'],
    displayFields: ['name'],
    recordPath: '/salesoffice/{{id}}',
    searchPath: '/salesoffice',
  },
  customSearchCaseTemplate: {
    searchFields: ['id','subject','createdAt','status','priority'],
    displayFields: ['subject'],
    recordPath: '/casetemplates/{{id}}',
    searchPath: '/casetemplates',
  },
  Comment: {
    global: true,
    searchFields: ['comment'],
    displayFields: ['comment'],
    recordPath: '/cases/{{id}}/comments#{{commentID}}',
    searchPath: '/comments'
  },
  Note: {
    global: true,
    searchFields: ['note'],
    displayFields: ['note'],
    recordPath: '/cases/{{id}}/notes#{{noteID}}',
    searchPath: '/notes'
  },
  //for Task list page
  TaskStepsListCustom: {
    searchFields: ['id','subject','priority', 'status', 'assignee', 'type', 'quickNote'],
    displayFields: ['subject','priority', 'status', 'assignee', 'type'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  //for Service list page
  ServiceCustom: {
    searchFields: ['name', 'phone', 'merchantNumber', 'email', 'nameLegal', 'status'],
    displayFields: ['name'],
    recordPath: '/services/{{id}}',
    searchPath: '/services'
  },
  //for Account list page
  AccountCustom: {
    searchFields: [
      'name', 'addressPhysical.locality', 'addressPhysical.street_address',
      'addressMailing.locality','addressMailing.street_address'
    ],
    displayFields: ['name'],
    recordPath: '/accounts/{{id}}',
    searchPath: '/accounts'
  },
  //for Attachment
  Attachment: {
    global: true,
    searchFields: [
      'name', 'description'
    ],
    displayFields: ['name'],
    recordPath: '/attachments/{{id}}',
    searchPath: '/attachments'
  },
  //for Companies list
  CompanyCustom: {
    searchFields: ['name'],
    displayFields: ['name'],
    recordPath: '/companies/{{id}}',
    searchPath: '/companies'
  },
  CommentsCustom: {
    searchFields: ['comment'],
    displayFields: ['comment'],
    recordPath: '/cases/{{id}}/comments#{{commentID}}',
    searchPath: '/comments'
  },
  CaseLinkCustom: {
    searchFields: [
      'esData.linkCase.subject',
      'esData.linkCase.quickNote',
      // 'esData.case.user.given_name',
      // 'esData.case.user.family_name',
      // 'esData.case.team.name',
      // 'esData.case.template.subject',
      // 'reason',
    ],
    displayFields: ['reason'],
    recordPath: '/cases/{{id}}',
    searchPath: '/cases',
  },
  // lookup change
  Change: {
    searchFields: ['id','change', 'createdAt'],
    displayFields: ['id'],
    recordPath: '/changes/{{id}}',
    searchPath: '/changes'
  },
  ServiceProductsCustom: {
    searchFields: [
    'esData.product.name',
    'esData.product.productOption.name',
    'esData.product.status',
    'esData.product.platform',
    'esData.product.terminalOrTsysId',
    'esData.product.midV',
    'esData.product.billingMethod',
    'esData.product.serial',
    'esData.product.createdAt',
    'esData.product.replacementDate'
    ],
    displayFields: ['name'],
    recordPath: '/products/{{id}}',
    searchPath: '/products'
  },
  PersonAccount: {
    searchFields: [
      'esData.person.given_name',
      'esData.person.family_name',
      'esData.person.email',
      'esData.person.addressMailing',
      'esData.person.addressMailing',
      'esData.person.ssn',
      'esData.person.dob',
      'esData.person.phone_mobile',
      'esData.person.phone_other',
      'esData.person.phone_number',
      'esData.person.phone_home',
      'role',
      'title',
      'email',
      'business_email',
      'other_email',
      'ownership',
      'esData.account.name',
      'esData.account.merchantNumber',
      'esData.account.phone',
      'esData.account.nameLegal',
      'esData.account.namePrevious',
      'esData.account.addressPhysical',
      'esData.account.addressMailing',
      'esData.account.phoneBusiness',
      'esData.account.phoneSupport',
    ],
    displayFields: ['id'],
    recordPath: '/person-accounts/{{id}}',
    searchPath: '/person-accounts'
  },
  PersonCompany: {
    searchFields: [
      'esData.person.given_name',
      'esData.person.family_name',            
      'esData.person.phone_mobile',
      'esData.person.phone_number',
      'esData.person.email',
      'esData.person.ssn',
      'esData.person.dob',
      'esData.person.createdAt',
      'esData.company.name',
      'esData.company.phone',
      'esData.company.phoneExt'
    ],
    displayFields: ['id'],
    recordPath: '/person-companys/{{id}}',
    searchPath: '/person-companys'
  },
  TaskAccountsCustom: {
    searchFields: [
      'esData.task.subject',
      'esData.task.status',
      'esData.task.case.subject',
      'esData.task.user.given_name',
      'esData.task.user.family_name',
      'esData.task.createdAt'
    ],
    displayFields: ['name'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  TaskSalesRep: {
    searchFields: [
      'esData.task.subject',
      'esData.task.status',
      'esData.task.createdAt'
    ],
    displayFields: ['name'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  TaskProduct: {
    searchFields: [
      'esData.task.subject',
      'esData.task.status',
      'esData.task.createdAt'
    ],
    displayFields: ['name'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  TaskCompany: {
    searchFields: [
      'esData.task.subject',
      'esData.task.status',
      'esData.task.createdAt'
    ],
    displayFields: ['name'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  TaskService: {
    searchFields: [
      'esData.task.subject',
      'esData.task.status',
      'esData.task.createdAt'
    ],
    displayFields: ['name'],
    recordPath: '/tasks/{{id}}',
    searchPath: '/tasks'
  },
  CaseAttachment: {
    searchFields: [
      'esData.attachment.name',
      'esData.attachment.description',
      'esData.attachment.type',
      'esData.createdAt',
      'esData.updatedBy.given_name',
      'esData.updatedBy.family_name'
    ],
    displayFields: ['name'],
  },
};

export default searchConfig;